import { Component, Input, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <header class="header" role="banner">
      <nav class="nav" role="navigation" aria-label="Navegación principal">
        <div class="nav-container">
          <div class="logo">
            <a routerLink="/" aria-label="Ir a página principal">
              <picture>
                <source srcset="/images/gray-logo-80.webp" type="image/webp">
                <img 
                  src="/images/gray-logo-80.webp" 
                  alt="Logo de Pezeta Solutions - Empresa de desarrollo de software personalizado" 
                  class="logo-img" 
                  width="40" 
                  height="40" 
                  loading="eager"
                  [attr.fetchpriority]="isHomePage ? 'high' : 'auto'"
                >
              </picture>
              <span class="logo-text">Pezeta Solutions</span>
            </a>
          </div>
          
          <!-- Mobile menu button -->
          <button 
            class="mobile-menu-btn"
            [class.active]="isMobileMenuOpen"
            (click)="toggleMobileMenu()"
            aria-label="Abrir menú de navegación"
            type="button"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <ul class="nav-menu" [class.active]="isMobileMenuOpen">
            <li>
              <a
                routerLink="/"
                [class.active]="isRouteActive('/')"
                (click)="closeMobileMenu()"
                title="Ir a la página de inicio - Chatbot Pezeta"
                aria-label="Ir a la página de inicio"
              >
                Inicio
              </a>
            </li>
            <li>
              <a
                (click)="scrollToSection('pricing')"
                class="nav-link"
                style="cursor: pointer;"
                title="Ver nuestros planes y precios"
                aria-label="Ir a la sección de precios"
              >
                Precios
              </a>
            </li>
            <li>
              <a
                routerLink="/blogs"
                [class.active]="isRouteActive('/blogs')"
                (click)="closeMobileMenu()"
                title="Leer artículos del blog"
                aria-label="Ir al blog"
              >
                Blog
              </a>
            </li>
            <li>
              <a
                routerLink="/login"
                class="nav-login"
                (click)="closeMobileMenu()"
                title="Acceder a tu cuenta"
                aria-label="Acceder al sistema"
              >
                Acceder
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  `,
  styles: []
})
export class NavigationComponent implements OnInit {
  @Input() currentPage: string = '';
  
  currentRoute = '';
  isMobileMenuOpen = false;
  isHomePage = false;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.url;
        this.isHomePage = this.currentRoute === '/';
        this.isMobileMenuOpen = false;
      });
    
    this.currentRoute = this.router.url;
    this.isHomePage = this.currentRoute === '/';
  }

  isRouteActive(route: string): boolean {
    if (route === '/') {
      return this.currentRoute === '/';
    }
    return this.currentRoute.startsWith(route);
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
  }

  scrollToSection(sectionId: string) {
    this.closeMobileMenu();
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }
}